var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1651,
    height: 891,
    viewBox: "0 0 1651 891",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_120_66",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1651,
    height: 891
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1651,
    height: 891,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_120_66)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_120_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.313 1.21368C289.453 -64.1957 352.709 -87.4828 351.442 -153.011C348.369 -311.988 -55.365 -154.348 -55.365 -154.348C-55.365 -154.348 -65.0155 423.823 78.6504 304.659C114.811 274.665 104.727 216.503 151.009 208.519C203.362 199.488 200.563 299.427 253.666 297.857C311.389 296.151 335.079 241.6 350.328 185.854C370.499 112.114 280.483 77.5142 285.313 1.21368Z",
    fill: "#EEEEEE",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.897 149.349C185.037 106.869 209.911 72.513 240.455 72.6134C270.999 72.7139 295.647 107.232 295.508 149.713C295.368 192.193 270.679 170.063 240.135 169.962C209.591 169.862 184.757 191.83 184.897 149.349Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3559 165.614C6.5264 113.756 24.8317 74.4183 62.3179 74.5415C99.8041 74.6647 142.276 114.203 142.105 166.061C141.935 217.918 111.635 190.902 74.1487 190.779C36.6625 190.656 6.1854 217.472 6.3559 165.614Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.291,
    cy: 122.891,
    r: 35.1945,
    transform: "rotate(-179.812 240.291 122.891)",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.783,
    cy: 137.404,
    r: 35.1945,
    transform: "rotate(-179.812 66.783 137.404)",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.491,
    cy: 140.492,
    rx: 18.8542,
    ry: 20.1112,
    transform: "rotate(-179.812 241.491 140.492)",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.5375,
    cy: 151.259,
    r: 18.8542,
    transform: "rotate(-179.812 75.5375 151.259)",
    fill: "black",
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_120_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.135 893.379C385.003 945.585 334.587 964.334 335.77 1016.62C338.639 1143.47 660.398 1016.62 660.398 1016.62C660.398 1016.62 666.582 555.226 552.252 650.693C523.475 674.723 531.675 721.108 494.764 727.601C453.01 734.945 454.981 655.188 412.611 656.58C366.553 658.093 347.792 701.686 335.77 746.211C319.867 805.106 391.789 832.48 388.135 893.379Z",
    fill: "#EEEEEE",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.882 774.907C469.882 808.806 449.674 836.286 424.746 836.286C399.818 836.286 379.61 808.806 379.61 774.907C379.61 741.008 399.818 758.603 424.746 758.603C449.674 758.603 469.882 741.008 469.882 774.907Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.305 761.459C610.305 802.841 595.801 834.28 565.888 834.28C535.974 834.28 501.979 802.841 501.979 761.459C501.979 720.077 526.228 741.556 556.142 741.556C586.055 741.556 610.305 720.077 610.305 761.459Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.743,
    cy: 796.165,
    r: 28.0847,
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 564.166,
    cy: 784.129,
    r: 28.0847,
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.734,
    cy: 795.162,
    r: 19.0575,
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555.139,
    cy: 787.138,
    r: 19.0575,
    fill: "black",
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_120_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.971 165.03C403.795 97.7206 337.075 77.4408 334.476 9.68663C328.171 -154.691 754.554 -15.9502 754.554 -15.9502C754.554 -15.9502 798.994 580.62 643.508 466.111C604.372 437.289 607.02 439.896 558.743 434.409C504.133 428.203 517.282 467.977 462.344 469.522C402.625 471.201 374.905 416.273 355.831 359.606C330.601 284.648 421.508 243.546 411.971 165.03Z",
    fill: "#EEEEEE",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.071 311.254C524.415 267.734 496.112 234.05 463.854 236.019C431.597 237.988 407.6 274.863 410.256 318.384C412.912 361.904 443.003 424.891 475.261 422.923C507.518 420.954 529.727 354.775 527.071 311.254Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.427 317.168C709.189 264.111 687.612 224.969 648.187 227.375C608.761 229.781 566.415 272.824 569.653 325.881C572.891 378.938 584.425 387.6 623.851 385.194C663.277 382.788 715.665 370.224 712.427 317.168Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 36.41,
    transform: "matrix(0.998143 -0.0609155 -0.0609155 -0.998143 465.727 288.015)",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 37.7104,
    ry: 36.41,
    transform: "matrix(0.998143 -0.0609155 -0.0609155 -0.998143 647.092 292.58)",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 24.7068,
    transform: "matrix(0.998143 -0.0609155 -0.0609155 -0.998143 462.227 294.743)",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 24.7068,
    transform: "matrix(0.998143 -0.0609155 -0.0609155 -0.998143 631.437 292.233)",
    fill: "black",
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_120_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M751.52 783.781C748.046 841.665 692.133 862.453 693.444 920.426C696.627 1061.07 1053.47 920.426 1053.47 920.426C1053.47 920.426 1060.33 408.854 933.532 514.704C901.617 541.347 910.711 592.776 869.775 599.975C823.469 608.118 825.655 519.688 778.664 521.231C727.584 522.909 706.778 571.242 693.444 620.609C675.808 685.909 755.572 716.26 751.52 783.781Z",
    fill: "#EEEEEE",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.212 654.106C842.212 690.666 819.825 720.303 792.208 720.303C764.591 720.303 742.203 690.666 742.203 654.106C742.203 617.546 792.208 636.522 792.208 636.522C792.208 636.522 842.212 617.546 842.212 654.106Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.48 771.729C920.48 808.647 897.898 838.575 870.041 838.575C842.184 838.575 819.601 808.647 819.601 771.729C819.601 734.811 842.184 753.973 870.041 753.973C897.898 753.973 920.48 734.811 920.48 771.729Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.879 639.32C997.879 684.352 981.81 718.564 948.67 718.564C915.53 718.564 877.868 684.352 877.868 639.32C877.868 594.288 937.873 617.661 937.873 617.661C937.873 617.661 997.879 594.288 997.879 639.32Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 790.903,
    cy: 675.951,
    r: 31.3072,
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 946.57,
    cy: 664.646,
    r: 31.3072,
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.514 670.066C813.514 680.002 805.532 695.953 795.686 695.953C785.84 695.953 777.859 680.002 777.859 670.066C777.859 660.131 795.686 679.719 795.686 679.719C795.686 679.719 813.514 660.131 813.514 670.066Z",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.223 655.982C962.223 665.315 954.825 680.3 945.7 680.3C936.574 680.3 929.177 665.315 929.177 655.982C929.177 646.649 945.7 665.049 945.7 665.049C945.7 665.049 962.223 646.649 962.223 655.982Z",
    fill: "black",
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_120_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1515.48 505.144C1598.76 500.071 1628.6 419.607 1712.03 421.418C1914.42 425.811 1712.5 939.345 1712.5 939.345C1712.5 939.345 976.376 949.883 1128.52 767.336C1166.82 721.389 1240.84 734.404 1251.14 675.505C1262.8 608.878 1135.55 612.14 1137.71 544.537C1140.06 471.053 1209.58 441.057 1280.6 421.811C1374.54 396.354 1418.32 511.061 1515.48 505.144Z",
    fill: "#EEEEEE",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.58 635.738C1380.66 635.689 1424.48 603.408 1424.44 563.637C1424.41 523.865 1380.53 491.664 1326.45 491.714C1272.36 491.763 1300.47 523.978 1300.5 563.75C1300.54 603.521 1272.5 635.788 1326.58 635.738Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.33 859.797C1371.35 859.737 1421.49 836.55 1421.45 788.825C1421.4 741.099 1371.19 686.907 1305.17 686.967C1239.15 687.027 1273.45 725.685 1273.5 773.411C1273.54 821.136 1239.31 859.857 1305.33 859.797Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.35 606.904C1383.48 606.882 1359.33 586.843 1359.31 562.096C1359.28 537.35 1383.39 517.266 1359.27 517.288C1335.14 517.31 1315.6 537.389 1315.62 562.136C1315.64 586.883 1335.22 606.926 1359.35 606.904Z",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.64 794.158C1369.38 794.136 1389.46 809.47 1389.44 785.216C1389.42 760.961 1369.34 741.318 1344.59 741.34C1319.84 741.363 1299.8 761.043 1299.82 785.297C1299.84 809.552 1319.89 794.181 1344.64 794.158Z",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 36.8064,
    ry: 38.4066,
    transform: "matrix(0.000912576 1 1 -0.000912576 1350.84 576.506)",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 38.4066,
    ry: 36.8064,
    transform: "matrix(0.000912576 1 1 -0.000912576 1343.04 798.952)",
    fill: "black",
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_120_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1715.46 387.937C1788.81 392.405 1815.09 463.268 1888.56 461.673C2066.8 457.804 1888.97 5.54114 1888.97 5.54114C1888.97 5.54114 1240.68 -3.73954 1374.67 157.027C1408.4 197.492 1405.4 194.797 1414.48 246.669C1424.75 305.346 1380.86 293.707 1382.76 353.244C1384.83 417.96 1446.06 444.377 1508.6 461.327C1591.34 483.747 1629.89 382.725 1715.46 387.937Z",
    fill: "#EEEEEE",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.78 272.924C1597.03 272.967 1635.31 301.397 1635.28 336.423C1635.25 371.449 1596.92 399.808 1549.66 399.765C1502.41 399.722 1432.3 371.264 1432.34 336.238C1432.37 301.212 1502.52 272.881 1549.78 272.924Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.33 72.7804C1588.94 72.8329 1632.68 93.6299 1632.65 136.44C1632.61 179.249 1588.79 227.861 1531.18 227.808C1473.57 227.756 1463.45 215.84 1463.49 173.031C1463.53 130.221 1473.72 72.7278 1531.33 72.7804Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1578.91,
    cy: 337.781,
    r: 39.4616,
    transform: "rotate(-89.9477 1578.91 337.781)",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1564.99,
    cy: 141.869,
    rx: 40.871,
    ry: 39.4616,
    transform: "rotate(-89.9477 1564.99 141.869)",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1554.96,
    cy: 320.847,
    rx: 16.9121,
    ry: 15.5028,
    transform: "rotate(-89.9477 1554.96 320.847)",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1550.91,
    cy: 134.81,
    r: 16.9121,
    transform: "rotate(-89.9477 1550.91 134.81)",
    fill: "white",
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_120_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.291 747.005C299.123 810.874 360.802 833.812 359.355 897.78C355.845 1052.97 -37.7958 897.78 -37.7958 897.78C-37.7958 897.78 -45.3613 333.307 94.5105 450.102C129.716 479.5 127.372 476.893 172.529 484.836C223.611 493.821 213.512 455.601 265.348 457.304C321.695 459.155 344.647 512.487 359.355 566.958C378.811 639.012 290.821 672.501 295.291 747.005Z",
    fill: "#EEEEEE",
    stroke: "#DDDDDD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.736 634.131C197.736 675.514 222.459 709.062 252.956 709.062C283.453 709.062 308.176 675.514 308.176 634.131C308.176 592.748 283.453 605.33 252.956 605.33C222.459 605.33 197.736 592.748 197.736 634.131Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4875 618.338C23.4875 668.499 41.5605 706.608 78.8347 706.608C116.109 706.608 158.469 668.499 158.469 618.338C158.469 568.177 148.103 559.355 110.829 559.355C73.5544 559.355 23.4875 568.177 23.4875 618.338Z",
    fill: "#C4C4C4",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 34.3589,
    transform: "matrix(-1 0 0 1 251.729 659.978)",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 34.3589,
    transform: "matrix(-1 0 0 1 82.3885 645.252)",
    fill: "black",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.582 683.605C240.486 688.746 249.439 688.127 254.58 682.223C259.721 676.319 249.794 678.056 243.89 672.915C237.986 667.774 238.34 657.703 233.2 663.607C228.059 669.511 228.678 678.465 234.582 683.605Z",
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.209 665.818C65.209 673.436 71.8017 679.611 79.9343 679.611C88.0668 679.611 94.6595 673.436 94.6595 665.818C94.6595 658.2 88.0668 665.818 79.9343 665.818C71.8017 665.818 65.209 658.2 65.209 665.818Z",
    fill: "white",
    stroke: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M830.9 132.599V121.911H801.65V103.349H834.556V92.6143H788.431V160.864H801.65V132.599H830.9ZM882.134 109.208C878.728 109.208 875.587 110.036 872.712 111.692C869.837 113.317 867.369 115.567 865.306 118.442L865.212 117.317L864.697 110.146H852.556V160.864H865.587V130.396C866.181 128.958 866.931 127.708 867.837 126.646C868.744 125.583 869.837 124.708 871.119 124.021C872.181 123.427 873.384 122.989 874.728 122.708C876.103 122.396 877.634 122.239 879.322 122.239C880.947 122.239 882.65 122.349 884.431 122.567C886.244 122.755 888.009 123.052 889.728 123.458L891.65 110.474C890.619 110.161 889.259 109.88 887.572 109.63C885.916 109.349 884.103 109.208 882.134 109.208ZM901.587 135.036V136.021C901.587 139.739 902.119 143.177 903.181 146.333C904.244 149.458 905.806 152.177 907.869 154.489C909.9 156.802 912.4 158.614 915.369 159.927C918.369 161.208 921.775 161.849 925.587 161.849C929.369 161.849 932.744 161.208 935.712 159.927C938.681 158.614 941.181 156.802 943.212 154.489C945.244 152.177 946.791 149.458 947.853 146.333C948.916 143.177 949.447 139.739 949.447 136.021V135.036C949.447 131.349 948.916 127.942 947.853 124.817C946.791 121.661 945.244 118.927 943.212 116.614C941.15 114.302 938.634 112.489 935.666 111.177C932.697 109.864 929.306 109.208 925.494 109.208C921.681 109.208 918.291 109.864 915.322 111.177C912.384 112.489 909.9 114.302 907.869 116.614C905.806 118.927 904.244 121.661 903.181 124.817C902.119 127.942 901.587 131.349 901.587 135.036ZM914.619 136.021V135.036C914.619 132.974 914.822 131.021 915.228 129.177C915.634 127.333 916.275 125.708 917.15 124.302C918.025 122.896 919.15 121.786 920.525 120.974C921.9 120.161 923.556 119.755 925.494 119.755C927.462 119.755 929.134 120.161 930.509 120.974C931.884 121.786 933.009 122.896 933.884 124.302C934.728 125.708 935.353 127.333 935.759 129.177C936.166 131.021 936.369 132.974 936.369 135.036V136.021C936.369 138.146 936.166 140.146 935.759 142.021C935.353 143.864 934.728 145.474 933.884 146.849C933.009 148.255 931.884 149.364 930.509 150.177C929.134 150.989 927.494 151.396 925.587 151.396C923.619 151.396 921.931 150.989 920.525 150.177C919.15 149.364 918.025 148.255 917.15 146.849C916.275 145.474 915.634 143.864 915.228 142.021C914.822 140.146 914.619 138.146 914.619 136.021ZM959.244 135.036V136.021C959.244 139.739 959.775 143.177 960.837 146.333C961.9 149.458 963.462 152.177 965.525 154.489C967.556 156.802 970.056 158.614 973.025 159.927C976.025 161.208 979.431 161.849 983.244 161.849C987.025 161.849 990.4 161.208 993.369 159.927C996.337 158.614 998.837 156.802 1000.87 154.489C1002.9 152.177 1004.45 149.458 1005.51 146.333C1006.57 143.177 1007.1 139.739 1007.1 136.021V135.036C1007.1 131.349 1006.57 127.942 1005.51 124.817C1004.45 121.661 1002.9 118.927 1000.87 116.614C998.806 114.302 996.291 112.489 993.322 111.177C990.353 109.864 986.962 109.208 983.15 109.208C979.337 109.208 975.947 109.864 972.978 111.177C970.041 112.489 967.556 114.302 965.525 116.614C963.462 118.927 961.9 121.661 960.837 124.817C959.775 127.942 959.244 131.349 959.244 135.036ZM972.275 136.021V135.036C972.275 132.974 972.478 131.021 972.884 129.177C973.291 127.333 973.931 125.708 974.806 124.302C975.681 122.896 976.806 121.786 978.181 120.974C979.556 120.161 981.212 119.755 983.15 119.755C985.119 119.755 986.791 120.161 988.166 120.974C989.541 121.786 990.666 122.896 991.541 124.302C992.384 125.708 993.009 127.333 993.416 129.177C993.822 131.021 994.025 132.974 994.025 135.036V136.021C994.025 138.146 993.822 140.146 993.416 142.021C993.009 143.864 992.384 145.474 991.541 146.849C990.666 148.255 989.541 149.364 988.166 150.177C986.791 150.989 985.15 151.396 983.244 151.396C981.275 151.396 979.587 150.989 978.181 150.177C976.806 149.364 975.681 148.255 974.806 146.849C973.931 145.474 973.291 143.864 972.884 142.021C972.478 140.146 972.275 138.146 972.275 136.021ZM1017.37 135.13V136.114C1017.37 139.802 1017.84 143.224 1018.77 146.38C1019.74 149.505 1021.12 152.208 1022.9 154.489C1024.68 156.771 1026.82 158.567 1029.32 159.88C1031.85 161.161 1034.7 161.802 1037.85 161.802C1039.45 161.802 1040.93 161.63 1042.31 161.286C1043.71 160.942 1044.99 160.458 1046.15 159.833C1046.93 159.396 1047.67 158.896 1048.35 158.333C1049.04 157.771 1049.7 157.146 1050.32 156.458V159.364C1050.32 161.083 1050.07 162.63 1049.57 164.005C1049.1 165.38 1048.42 166.536 1047.51 167.474C1046.51 168.505 1045.26 169.286 1043.76 169.817C1042.29 170.349 1040.6 170.614 1038.7 170.614C1037.51 170.614 1036.35 170.489 1035.23 170.239C1034.13 170.021 1033.07 169.677 1032.04 169.208C1030.98 168.739 1029.96 168.13 1028.99 167.38C1028.02 166.661 1027.12 165.817 1026.27 164.849L1020.42 172.771C1021.51 174.177 1022.82 175.38 1024.35 176.38C1025.88 177.411 1027.51 178.255 1029.23 178.911C1030.95 179.567 1032.68 180.052 1034.43 180.364C1036.18 180.677 1037.82 180.833 1039.35 180.833C1042.92 180.833 1046.17 180.349 1049.1 179.38C1052.07 178.442 1054.62 177.052 1056.74 175.208C1058.84 173.364 1060.46 171.099 1061.62 168.411C1062.81 165.724 1063.4 162.661 1063.4 159.224V110.146H1051.54L1051.02 114.974C1050.4 114.192 1049.71 113.489 1048.96 112.864C1048.21 112.208 1047.4 111.646 1046.52 111.177C1045.37 110.521 1044.07 110.036 1042.63 109.724C1041.23 109.38 1039.67 109.208 1037.95 109.208C1034.76 109.208 1031.9 109.833 1029.37 111.083C1026.84 112.333 1024.68 114.099 1022.9 116.38C1021.12 118.661 1019.74 121.396 1018.77 124.583C1017.84 127.771 1017.37 131.286 1017.37 135.13ZM1030.45 136.114V135.13C1030.45 133.005 1030.67 131.021 1031.1 129.177C1031.54 127.302 1032.21 125.661 1033.12 124.255C1033.99 122.88 1035.1 121.802 1036.45 121.021C1037.79 120.208 1039.38 119.802 1041.23 119.802C1042.23 119.802 1043.15 119.896 1043.99 120.083C1044.87 120.271 1045.67 120.536 1046.38 120.88C1047.23 121.286 1047.98 121.817 1048.63 122.474C1049.29 123.13 1049.85 123.896 1050.32 124.771V146.239C1049.88 147.021 1049.37 147.724 1048.77 148.349C1048.18 148.974 1047.49 149.505 1046.71 149.942C1045.96 150.349 1045.12 150.661 1044.18 150.88C1043.27 151.099 1042.26 151.208 1041.13 151.208C1039.29 151.208 1037.7 150.817 1036.35 150.036C1035.01 149.255 1033.9 148.177 1033.02 146.802C1032.15 145.458 1031.49 143.88 1031.06 142.067C1030.65 140.224 1030.45 138.239 1030.45 136.114ZM1109.06 146.942C1109.06 147.724 1108.85 148.442 1108.45 149.099C1108.07 149.755 1107.49 150.333 1106.71 150.833C1105.9 151.333 1104.85 151.739 1103.57 152.052C1102.32 152.333 1100.85 152.474 1099.17 152.474C1097.76 152.474 1096.38 152.333 1095.04 152.052C1093.73 151.771 1092.56 151.317 1091.52 150.692C1090.49 150.099 1089.65 149.317 1088.99 148.349C1088.34 147.349 1087.96 146.161 1087.87 144.786H1075.45C1075.45 146.849 1075.95 148.911 1076.95 150.974C1077.98 153.005 1079.48 154.817 1081.45 156.411C1083.42 158.036 1085.85 159.349 1088.76 160.349C1091.7 161.349 1095.07 161.849 1098.88 161.849C1102.35 161.849 1105.49 161.474 1108.31 160.724C1111.12 159.942 1113.52 158.864 1115.52 157.489C1117.49 156.114 1119.01 154.489 1120.07 152.614C1121.17 150.708 1121.71 148.63 1121.71 146.38C1121.71 143.942 1121.17 141.849 1120.07 140.099C1119.01 138.317 1117.52 136.802 1115.62 135.552C1113.71 134.333 1111.45 133.333 1108.82 132.552C1106.2 131.771 1103.35 131.13 1100.29 130.63C1098.17 130.317 1096.42 129.958 1095.04 129.552C1093.67 129.114 1092.59 128.63 1091.81 128.099C1090.99 127.599 1090.43 127.036 1090.12 126.411C1089.81 125.755 1089.65 125.052 1089.65 124.302C1089.65 123.552 1089.82 122.849 1090.17 122.192C1090.54 121.505 1091.07 120.911 1091.76 120.411C1092.51 119.849 1093.48 119.411 1094.67 119.099C1095.85 118.786 1097.24 118.63 1098.84 118.63C1100.71 118.63 1102.31 118.864 1103.62 119.333C1104.96 119.802 1106.02 120.427 1106.81 121.208C1107.37 121.802 1107.79 122.474 1108.07 123.224C1108.35 123.942 1108.49 124.724 1108.49 125.567H1121.52C1121.52 123.224 1121.01 121.052 1119.98 119.052C1118.95 117.052 1117.46 115.317 1115.52 113.849C1113.56 112.411 1111.17 111.286 1108.35 110.474C1105.54 109.63 1102.37 109.208 1098.84 109.208C1095.46 109.208 1092.43 109.63 1089.74 110.474C1087.06 111.317 1084.77 112.458 1082.9 113.896C1081.02 115.333 1079.59 117.005 1078.59 118.911C1077.59 120.817 1077.09 122.817 1077.09 124.911C1077.09 127.067 1077.57 128.974 1078.54 130.63C1079.54 132.286 1080.92 133.739 1082.67 134.989C1084.42 136.271 1086.51 137.364 1088.95 138.271C1091.42 139.146 1094.13 139.88 1097.1 140.474C1099.45 140.911 1101.38 141.349 1102.92 141.786C1104.45 142.224 1105.68 142.692 1106.62 143.192C1107.52 143.724 1108.15 144.286 1108.49 144.88C1108.87 145.474 1109.06 146.161 1109.06 146.942ZM832.587 263.067V262.083C832.587 259.427 832.369 256.911 831.931 254.536C831.494 252.13 830.853 249.942 830.009 247.974C829.197 246.224 828.259 244.646 827.197 243.239C826.134 241.802 824.931 240.583 823.587 239.583C822.087 238.521 820.416 237.692 818.572 237.099C816.728 236.505 814.712 236.208 812.525 236.208C810.775 236.208 809.15 236.38 807.65 236.724C806.15 237.067 804.775 237.567 803.525 238.224C802.525 238.755 801.587 239.396 800.712 240.146C799.837 240.864 799.041 241.677 798.322 242.583V215.864H789.65V287.864H797.619L798.041 282.099C798.603 282.817 799.197 283.474 799.822 284.067C800.447 284.661 801.103 285.208 801.791 285.708C803.228 286.708 804.837 287.474 806.619 288.005C808.431 288.536 810.431 288.802 812.619 288.802C814.525 288.802 816.291 288.567 817.916 288.099C819.572 287.63 821.087 286.974 822.462 286.13C824.369 284.911 825.994 283.38 827.337 281.536C828.712 279.661 829.822 277.552 830.666 275.208C831.291 273.427 831.759 271.521 832.072 269.489C832.416 267.427 832.587 265.286 832.587 263.067ZM823.916 262.083V263.067C823.916 264.567 823.822 266.036 823.634 267.474C823.447 268.911 823.15 270.255 822.744 271.505C822.244 273.161 821.572 274.661 820.728 276.005C819.884 277.349 818.837 278.458 817.587 279.333C816.65 280.021 815.587 280.552 814.4 280.927C813.212 281.271 811.9 281.442 810.462 281.442C808.962 281.442 807.587 281.255 806.337 280.88C805.087 280.474 803.962 279.911 802.962 279.192C801.962 278.474 801.072 277.646 800.291 276.708C799.541 275.739 798.884 274.692 798.322 273.567V251.396C798.853 250.271 799.494 249.239 800.244 248.302C801.025 247.333 801.916 246.489 802.916 245.771C803.884 245.083 804.994 244.552 806.244 244.177C807.494 243.771 808.869 243.567 810.369 243.567C811.744 243.567 812.994 243.724 814.119 244.036C815.244 244.349 816.259 244.786 817.166 245.349C818.478 246.13 819.587 247.208 820.494 248.583C821.4 249.958 822.134 251.474 822.697 253.13C823.103 254.474 823.4 255.911 823.587 257.442C823.806 258.942 823.916 260.489 823.916 262.083ZM851.337 308.349C853.619 308.349 855.634 307.927 857.384 307.083C859.134 306.239 860.666 305.192 861.978 303.942C863.291 302.692 864.4 301.333 865.306 299.864C866.244 298.396 867.009 297.005 867.603 295.692L893.337 237.146H883.634L870.556 270.052L868.166 276.005L865.916 269.864L851.994 237.146H842.291L864.134 285.474L860.666 292.224C860.353 292.849 859.916 293.646 859.353 294.614C858.822 295.583 858.181 296.521 857.431 297.427C856.65 298.333 855.759 299.114 854.759 299.771C853.791 300.427 852.712 300.755 851.525 300.755C851.087 300.755 850.478 300.724 849.697 300.661C848.947 300.63 848.181 300.583 847.4 300.521L845.994 307.599C846.556 307.724 847.384 307.88 848.478 308.067C849.572 308.255 850.525 308.349 851.337 308.349ZM1005.32 287.864V219.614H996.556L996.416 270.521L969.931 219.614H961.119V287.864H969.884L970.025 236.864L996.509 287.864H1005.32ZM1021.59 237.146V244.692H1038.84V280.364H1021.59V287.864H1064.06V280.364H1047.51V237.146H1021.59ZM1037.71 223.833C1037.71 225.239 1038.13 226.411 1038.98 227.349C1039.85 228.286 1041.17 228.755 1042.92 228.755C1044.63 228.755 1045.93 228.286 1046.81 227.349C1047.68 226.411 1048.12 225.239 1048.12 223.833C1048.12 223.052 1047.99 222.333 1047.74 221.677C1047.49 221.021 1047.12 220.474 1046.62 220.036C1046.21 219.63 1045.7 219.317 1045.07 219.099C1044.45 218.849 1043.73 218.724 1042.92 218.724C1042.1 218.724 1041.37 218.849 1040.71 219.099C1040.09 219.317 1039.57 219.63 1039.17 220.036C1038.67 220.505 1038.29 221.067 1038.04 221.724C1037.82 222.38 1037.71 223.083 1037.71 223.833ZM1095.18 287.864H1101.79L1122.46 237.146H1113.6L1099.4 275.396L1098.56 278.536L1097.76 275.396L1083.23 237.146H1074.32L1095.18 287.864ZM1168.87 287.864H1177.92V287.114C1177.35 285.708 1176.92 284.067 1176.6 282.192C1176.29 280.286 1176.13 278.489 1176.13 276.802V253.224C1176.13 250.38 1175.62 247.896 1174.59 245.771C1173.56 243.646 1172.15 241.864 1170.37 240.427C1168.56 239.021 1166.42 237.974 1163.95 237.286C1161.48 236.567 1158.81 236.208 1155.93 236.208C1152.77 236.208 1149.95 236.646 1147.45 237.521C1144.98 238.396 1142.88 239.536 1141.17 240.942C1139.42 242.38 1138.07 243.989 1137.13 245.771C1136.23 247.552 1135.76 249.364 1135.73 251.208H1144.45C1144.45 250.146 1144.7 249.13 1145.2 248.161C1145.73 247.161 1146.46 246.302 1147.4 245.583C1148.34 244.864 1149.48 244.286 1150.82 243.849C1152.2 243.411 1153.74 243.192 1155.46 243.192C1157.31 243.192 1158.96 243.427 1160.43 243.896C1161.93 244.364 1163.2 245.021 1164.23 245.864C1165.26 246.739 1166.06 247.786 1166.62 249.005C1167.18 250.224 1167.46 251.599 1167.46 253.13V257.114H1157.99C1154.46 257.114 1151.26 257.458 1148.38 258.146C1145.54 258.833 1143.1 259.864 1141.07 261.239C1139.04 262.646 1137.46 264.396 1136.34 266.489C1135.24 268.583 1134.7 271.021 1134.7 273.802C1134.7 275.927 1135.1 277.911 1135.92 279.755C1136.76 281.567 1137.95 283.13 1139.48 284.442C1140.98 285.786 1142.81 286.849 1144.96 287.63C1147.15 288.411 1149.59 288.802 1152.27 288.802C1153.93 288.802 1155.49 288.63 1156.96 288.286C1158.43 287.942 1159.82 287.474 1161.13 286.88C1162.42 286.286 1163.59 285.599 1164.65 284.817C1165.74 284.036 1166.73 283.208 1167.6 282.333C1167.7 283.396 1167.84 284.427 1168.02 285.427C1168.24 286.396 1168.52 287.208 1168.87 287.864ZM1153.54 281.255C1151.85 281.255 1150.37 281.036 1149.09 280.599C1147.81 280.161 1146.74 279.552 1145.9 278.771C1145.06 278.021 1144.42 277.114 1143.98 276.052C1143.57 274.989 1143.37 273.833 1143.37 272.583C1143.37 271.271 1143.6 270.099 1144.07 269.067C1144.57 268.036 1145.29 267.146 1146.23 266.396C1147.54 265.333 1149.31 264.552 1151.52 264.052C1153.77 263.521 1156.4 263.255 1159.4 263.255H1167.46V273.521C1166.96 274.521 1166.27 275.489 1165.4 276.427C1164.52 277.333 1163.49 278.146 1162.31 278.864C1161.09 279.583 1159.74 280.161 1158.27 280.599C1156.81 281.036 1155.23 281.255 1153.54 281.255ZM1226.52 287.864H1235.57V287.114C1235.01 285.708 1234.57 284.067 1234.26 282.192C1233.95 280.286 1233.79 278.489 1233.79 276.802V253.224C1233.79 250.38 1233.27 247.896 1232.24 245.771C1231.21 243.646 1229.81 241.864 1228.02 240.427C1226.21 239.021 1224.07 237.974 1221.6 237.286C1219.13 236.567 1216.46 236.208 1213.59 236.208C1210.43 236.208 1207.6 236.646 1205.1 237.521C1202.63 238.396 1200.54 239.536 1198.82 240.942C1197.07 242.38 1195.73 243.989 1194.79 245.771C1193.88 247.552 1193.42 249.364 1193.38 251.208H1202.1C1202.1 250.146 1202.35 249.13 1202.85 248.161C1203.38 247.161 1204.12 246.302 1205.06 245.583C1205.99 244.864 1207.13 244.286 1208.48 243.849C1209.85 243.411 1211.4 243.192 1213.12 243.192C1214.96 243.192 1216.62 243.427 1218.09 243.896C1219.59 244.364 1220.85 245.021 1221.88 245.864C1222.92 246.739 1223.71 247.786 1224.27 249.005C1224.84 250.224 1225.12 251.599 1225.12 253.13V257.114H1215.65C1212.12 257.114 1208.92 257.458 1206.04 258.146C1203.2 258.833 1200.76 259.864 1198.73 261.239C1196.7 262.646 1195.12 264.396 1193.99 266.489C1192.9 268.583 1192.35 271.021 1192.35 273.802C1192.35 275.927 1192.76 277.911 1193.57 279.755C1194.42 281.567 1195.6 283.13 1197.13 284.442C1198.63 285.786 1200.46 286.849 1202.62 287.63C1204.81 288.411 1207.24 288.802 1209.93 288.802C1211.59 288.802 1213.15 288.63 1214.62 288.286C1216.09 287.942 1217.48 287.474 1218.79 286.88C1220.07 286.286 1221.24 285.599 1222.31 284.817C1223.4 284.036 1224.38 283.208 1225.26 282.333C1225.35 283.396 1225.49 284.427 1225.68 285.427C1225.9 286.396 1226.18 287.208 1226.52 287.864ZM1211.2 281.255C1209.51 281.255 1208.02 281.036 1206.74 280.599C1205.46 280.161 1204.4 279.552 1203.56 278.771C1202.71 278.021 1202.07 277.114 1201.63 276.052C1201.23 274.989 1201.02 273.833 1201.02 272.583C1201.02 271.271 1201.26 270.099 1201.73 269.067C1202.23 268.036 1202.95 267.146 1203.88 266.396C1205.2 265.333 1206.96 264.552 1209.18 264.052C1211.43 263.521 1214.06 263.255 1217.06 263.255H1225.12V273.521C1224.62 274.521 1223.93 275.489 1223.06 276.427C1222.18 277.333 1221.15 278.146 1219.96 278.864C1218.74 279.583 1217.4 280.161 1215.93 280.599C1214.46 281.036 1212.88 281.255 1211.2 281.255ZM1261.26 280.786L1291.87 243.286V237.146H1250.62V244.317H1280.48L1250.2 281.489V287.864H1293.56V280.786H1261.26Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_120_66",
    x: -88.0004,
    y: -252.516,
    width: 473.779,
    height: 609.855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.227451 0 0 0 0 0.890196 0 0 0 0 0.454902 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_120_66",
    x: 300.97,
    y: 609.186,
    width: 391.986,
    height: 500.313,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.623529 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_120_66",
    x: 301.907,
    y: -99.1651,
    width: 491.026,
    height: 616.379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.901961 0 0 0 0 0.862745 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_120_66",
    x: 658.394,
    y: 471.783,
    width: 427.642,
    height: 547.653,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.219608 0 0 0 0 0.219608 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_120_66",
    x: 1075.31,
    y: 389.618,
    width: 759.287,
    height: 586.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.423529 0 0 0 0 0.941176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_120_66",
    x: 1323.93,
    y: -23.0583,
    width: 676.45,
    height: 524.138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.721569 0 0 0 0 0.721569 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_66",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_120_66",
    x: -70.3679,
    y: 405.69,
    width: 465.036,
    height: 597.564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.94902 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_120_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_120_66",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.3e181d2037504d0d10169917840ca1ae.svg";
export { ForwardRef as ReactComponent };